import { createContext, useContext } from "react";

/**
 * id эмбеда видео (/embed/e/:embedId) для рекламных запросов внутри
 * плеера: sponsorCampaign(embedId) кладёт его в токен креатива, и показ
 * рекламы засчитывается эмбеду. Вне эмбеда (сайт арены, обычный
 * /embed/:contentId) значение null.
 */
const ContentEmbedContext = createContext(null);

export function useContentEmbedId() {
  return useContext(ContentEmbedContext);
}

export default ContentEmbedContext.Provider;
